import styled, { css } from 'styled-components';
import breakpointsMinWidth from '../../../../../../../../styling/breakpointsMinWidth';
import scrollBar from '../../../shared/scrollBar';

export const Children = styled.div`
  width: -webkit-fill-available;
  width: -moz-available;
  width: 100%;
  text-align: left;
  font-size: 12px;
  line-height: 24px;

  white-space: nowrap;

  display: flex;
  align-items: center;
  /* width: calc(100% - 24px); */
  overflow: auto;
  text-align: justify;
  scrollbar-width: none;

  span {
    white-space: pre;
    word-wrap: normal;
    width: 100%;
  }

  span:not('underline_highlight') {
    width: inherit;
    white-space: pre;
    word-wrap: normal;

    @supports (-moz-appearance: none) {
      white-space: pre;
    }
  }

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  ${(props) => {
    const { nodeType } = props;
    if (nodeType === 'phone_number' || nodeType === 'sender_phone_number') {
      return css`
        /* position: absolute; */
        margin-left: 60px;
        /* width: calc(100% - 82px); */
        span {
          width: 100%;
        }
      `;
    }

    return null;
  }}
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;
const returnInputWrapperFocused = ({ isFocused }) => {
  if (isFocused) {
    return css`
      border: 1px solid #8510df;
    `;
  }
  return null;
};
export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  border-radius: 4px;
  font-size: 12px;

  cursor: text;
  ${(props) => returnInputWrapperFocused(props)}

  @media ${breakpointsMinWidth.mobileMicroLg} {
    padding: 0 12px 0 15px;
  }
  @media ${breakpointsMinWidth.tabletSm} {
    height: 36px;
    padding: 0 11px 0 8px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    padding: 0 8px 0 8px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    padding: 0 10px 0 11px;
  }

  @media ${breakpointsMinWidth.desktopSm} {
    padding: 0 10px 0 11px;
  }

  @media ${breakpointsMinWidth.desktopMd} {
    height: 40px;
    padding: 0 14px 0 13px;
    font-size: 14px;
  }

  ${(props) => {
    const { nodeType, inputWrapperWidth } = props;
    if (nodeType === 'phone_number' || nodeType === 'sender_phone_number') {
      return css`
        position: relative;
        padding: 0 10px 0 0;
        @media ${breakpointsMinWidth.mobileMicroLg} {
          padding: 0 12px 0 0;
        }
        @media ${breakpointsMinWidth.tabletSm} {
          padding: 0 11px 0 0;
        }
        @media ${breakpointsMinWidth.tabletMd} {
          padding: 0 8px 0 0;
        }
        @media ${breakpointsMinWidth.tabletLg} {
          padding: 0 10px 0 0;
        }

        @media ${breakpointsMinWidth.desktopSm} {
          padding: 0 10px 0 0;
        }

        @media ${breakpointsMinWidth.desktopMd} {
          padding: 0 14px 0 0;
        }

        .react-tel-input {
          height: inherit;
          z-index: 1;
          border-radius: 4px 0 0 4px;

          .form-control {
            display: none;
          }

          .flag-dropdown {
            background: none;
            border: none;
            padding-right: 8px;
            border-right: 1px solid #eee;
            border-radius: 4px 0 0 4px;

            .selected-flag {
              width: 48;
              padding: 0;
              display: flex;
              justify-content: center;
              border-radius: 4px 0 0 4px;
            }

            .country-list {
              ${() => scrollBar({ width: '6px', height: '6px' })}
              width: ${inputWrapperWidth && `${inputWrapperWidth}px`};
              max-height: 158px;
              font-size: 12px;
              border-radius: 4px;
              box-shadow: 1px 0 4px rgba(0, 0, 0, 0.35);
              overflow-y: overlay;
              padding: 8px 2px 8px 8px;

              .country {
                padding: 4px 8px;
                display: flex;
                align-items: center;
                border-radius: 4px;
              }

              .flag {
                margin-top: 0;
              }

              @media ${breakpointsMinWidth.tabletMd} {
                max-height: 172px;
              }
              @media ${breakpointsMinWidth.tabletLg} {
                max-height: 184px;
              }
              @media ${breakpointsMinWidth.desktopSm} {
                max-height: 232px;
              }
              @media ${breakpointsMinWidth.desktopMd} {
                font-size: 14px;
              }
            }
          }
        }
      `;
    }

    return null;
  }}
`;
